module.exports = " <section v-show=item.selected> <p> <b>Наименование:</b> <a :href=\"'/territory/pa/index?id=' + item.object.TerritoryId + '&type=view-89'\" target=_blank> {{item.object.Name | fallback}} </a> </p> <p><b>Административный центр:</b> {{item.object.AdmCenter | fallback}}</p> <p><b>Уровень:</b> {{item.object.TypeName | fallback}}</p> <p><b>Описание:</b> {{item.object.Description | fallback}}</p> <div class=map-result-hint v-if=!item.layer>Объекта нет на карте</div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/TerritoryShapeView.vue
// module id = 212
// module chunks = 0